export const deleteSession = async ({ BeURL, sessionId }) => {
    try {
        const resp = await fetch(
            `${BeURL}/session/${sessionId}`,
            {
                method: "DELETE",
                credentials: "include",
            }
        );

        const data = await resp.json();
        return data;

    } catch (err) {
        console.error("deleteSession api error:", err);
        return {
            success: false,
            message: "Network error",
        };
    }
};
